import Login from "../../../login";

export default () => {
  return <Login/>
}